// extracted by mini-css-extract-plugin
module.exports = {"root":"Graph_root__zlOh5","header":"Graph_header__2mIfY","options":"Graph_options__3qpfa"};